module.exports = __webpack_public_path__ + "static/media/corknscrewcc-cover.7e3a182e.jpg";